// import axios from 'axios'
import Strapi from 'strapi-sdk-javascript'
import io from 'socket.io-client'
export const LS = {
  get JWT () {
    return window.localStorage.getItem('JWT-BADABING-SYSTEM')
  },
  set JWT (val) {
    if (val === false || val === null) {
      window.localStorage.removeItem('JWT-BADABING-SYSTEM')
      return
    }
    return window.localStorage.setItem('JWT-BADABING-SYSTEM', val)
  },

  get YOQBJWT () {
    return window.localStorage.getItem('YOQBJWT-BADABING-SYSTEM')
  },
  set YOQBJWT (val) {
    if (val === false || val === null) {
      window.localStorage.removeItem('YOQBJWT-BADABING-SYSTEM')
      return
    }
    return window.localStorage.setItem('YOQBJWT-BADABING-SYSTEM', val)
  },
  get YOQBUID () {
    return window.localStorage.getItem('YOQBUID-BADABING-SYSTEM')
  },
  set YOQBUID (val) {
    if (val === false || val === null) {
      window.localStorage.removeItem('YOQBUID-BADABING-SYSTEM')
      return
    }
    return window.localStorage.setItem('YOQBUID-BADABING-SYSTEM', val)
  },

  get UserID () {
    return window.localStorage.getItem('UserID-BADABING-SYSTEM')
  },
  set UserID (val) {
    if (val === false || val === null) {
      window.localStorage.removeItem('UserID-BADABING-SYSTEM')
      return
    }
    return window.localStorage.setItem('UserID-BADABING-SYSTEM', val)
  },

  get LoggedIn () {
    return window.localStorage.getItem('LoggedIn-BADABING-SYSTEM')
  },
  set LoggedIn (val) {
    if (val === false || val === null) {
      window.localStorage.removeItem('LoggedIn-BADABING-SYSTEM')
      return
    }
    return window.localStorage.setItem('LoggedIn-BADABING-SYSTEM', val)
  },

  get Profile () {
    return JSON.parse(window.localStorage.getItem('Profile-BADABING-SYSTEM') || 'false')
  },
  set Profile (val) {
    if (val === false || val === null) {
      window.localStorage.removeItem('Profile-BADABING-SYSTEM')
      return
    }
    return window.localStorage.setItem('Profile-BADABING-SYSTEM', JSON.stringify(val))
  }
}

export const getColors = () => {
  let offset = Math.random() * 360
  let allColors = {
    dark: {
      color1: `hsl(${(offset + 0).toFixed(0)}, 100%, 12.5%)`,
      color2: `hsl(${(offset + 308).toFixed(0)}, 94%, 12.5%)`,
      color3: `hsl(${(offset + 0).toFixed(0)}, 88%, 12.5%)`,
      color4: `hsl(${(offset + 166).toFixed(0)}, 81%, 12.5%)`
    },
    normal: {
      color1: `hsl(${(offset + 0).toFixed(0)}, 100%, 57%)`,
      color2: `hsl(${(offset + 308).toFixed(0)}, 94%, 55%)`,
      color3: `hsl(${(offset + 0).toFixed(0)}, 88%, 37%)`,
      color4: `hsl(${(offset + 166).toFixed(0)}, 81%, 56%)`
    },
    light: {
      color1: `hsl(${(offset + 0).toFixed(0)}, 100%, 90%)`,
      color2: `hsl(${(offset + 308).toFixed(0)}, 94%, 85%)`,
      color3: `hsl(${(offset + 0).toFixed(0)}, 88%, 97%)`,
      color4: `hsl(${(offset + 166).toFixed(0)}, 81%, 96%)`
    }
  }
  return allColors
}

// export const getAxios = (config = {}) => {
//   let headers = {
//   }
//   if (typeof LS.JWT === 'string' && LS.JWT !== 'undefined') {
//     headers.Authorization = `Bearer ${LS.JWT}`
//   }
//   return axios.create({
//     headers,
//     baseURL
//   })
// }

export const checkLogin = () => {
  return !!LS.userID
}

export const checkIsPALMS = () => {
  if (checkLogin()) {
    return LS.Profile.role.name === 'palms' || LS.Profile.role.type === 'palms'
  } else {
    return false
  }
}

let storeConfig = {
  cookie: {
    key: 'api-the-play-badabing-com',
    options: {
      path: '/'
    }
  },
  localStorage: {
    key: 'api-the-play-badabing-com'
  }
}
export const getBaseURL = () => {
  let dynamicURL = `https://playbadabing-api.herokuapp.com`
  /*
  if (process.env.NODE_ENV === 'development') {
    dynamicURL = `http://localhost:1333`
  }
  */
  return dynamicURL
}

export const getSiteBase = () => {
  return `${window.location.protocol}//${window.location.host}`
}

// oauth
export const strapi = new Strapi(getBaseURL(), storeConfig)
window.strapi = strapi

export const facebookLogin = () => {
  window.location = strapi.getProviderAuthenticationUrl('facebook')
}

export const googleLogin = () => {
  window.location = strapi.getProviderAuthenticationUrl('google')
}
export const twitterLogin = () => {
  window.location = strapi.getProviderAuthenticationUrl('twitter')
}
export const facebookArrive = () => {
  // Complete the authentication: (The SDK will store the access token for you)
  return strapi.authenticateProvider('facebook')
    .then(() => {
      LS.JWT = JSON.parse(window.localStorage.getItem(storeConfig.localStorage.key))
      return getMe()
        .then((me) => {
          LS.UserID = me._id
          LS.Profile = me
          LS.LoggedIn = true

          return true
        })
    }, () => {
      return false
    })
}

export const twitterArrive = () => {
  // Complete the authentication: (The SDK will store the access token for you)
  return strapi.authenticateProvider('twitter')
    .then(() => {
      LS.JWT = JSON.parse(window.localStorage.getItem(storeConfig.localStorage.key))
      return getMe()
        .then((me) => {
          LS.UserID = me._id
          LS.Profile = me
          LS.LoggedIn = true

          return true
        })
    }, () => {
      return false
    })
}

export const googleArrive = () => {
  return new Promise((resolve, reject) => {
    // Complete the authentication: (The SDK will store the access token for you)
    // let queryString = require('query-string')
    // let info = queryString.parse(window.location.search, {
    //   arrayFormat: 'bracket'
    // })
    // console.log(info)
    // LS.JWT = info.access_token
    // strapi.request('get',
    //   `/auth/google/callback?access_token=${info.access_token}`
    // )
    // strapi.request('get',
    //   `/auth/google/callback?access_token=${info.raw.id_token}`
    // )
    strapi.authenticateProvider('google')
      .then(() => {
        LS.JWT = JSON.parse(window.localStorage.getItem(storeConfig.localStorage.key))
        return getMe()
          .then((me) => {
            LS.UserID = me._id
            LS.Profile = me
            LS.LoggedIn = true

            resolve(true)
          }, () => {
            reject(new Error('email taken'))
          })
      }, () => {
        reject(new Error('email taken'))
      })
  })
}

export const strap = () => {
  let headers = {
    Authorization: `Bearer ${LS.JWT}`
  }
  let axios = require('axios')

  let baseURL = getBaseURL()

  if (!LS.JWT) {
    delete headers.Authorization
  }
  return axios.create({
    baseURL,
    headers
  })
}

export const register = ({ username, email, password }) => {
  return strap()
    .post('/auth/local/register', {
      username,
      email,
      password
    })
    .then(response => {
      // Handle success.
      console.log('Well done!')
      // console.log('User profile', response.data.user)
      // console.log('User token', response.data.jwt)

      LS.JWT = response.data.jwt
      LS.UserID = response.data.user._id
      LS.Profile = response.data.user
      LS.LoggedIn = true

      return response.data
    })
    // .catch(error => {
    //   // Handle error.
    //   console.log('An error occurred:', error)
    // })
}

export const getCurrentUserID = () => {
  if (LS.LoggedIn) {
    return LS.UserID
  } else {
    return false
  }
}

export const login = ({ identifier, password }) => {
  return strap()
    .post('/auth/local', {
      identifier,
      password
    })
    .then(response => {
      // Handle success.
      console.log('Well done!')
      // console.log('User profile', response.data.user)
      // console.log('User token', response.data.jwt)
      LS.JWT = response.data.jwt
      LS.UserID = response.data.user._id
      LS.Profile = response.data.user
      LS.LoggedIn = true

      return response.data
    })
    // .catch(error => {
    //   // Handle error.
    //   console.log('An error occurred:', error)
    // })
}

export const sortInbound = (arr) => {
  arr.forEach((item, index) => {
    if (typeof item.document.order === 'undefined') {
      item.document.order = index
    }
  })
  return arr.slice().sort((qa, qb) => {
    if (qa.document.order > qb.document.order) {
      return 1
    } else if (qa.document.order < qb.document.order) {
      return -1
    } else {
      return 0
    }
  })
}

export const assignIndexToOrderAfterDrag = (arr = []) => {
  arr.forEach((item, index) => {
    item.document.order = index
  })
  return arr
}

export const logout = () => {
  LS.JWT = false
  LS.UserID = false
  LS.LoggedIn = false
  LS.Profile = false
}

export const getMe = () => {
  return strap()
    .get('/users/me')
    .then(res => {
      return res.data
    })
}

// ------ GAME ------
export const createGame = ({
  title,
  userID,
  datetime,
  lastPlay,
  questions,
  meta,
  slug
}) => {
  return strap()
    .post('/games', {
      title,
      userID,
      datetime,
      lastPlay,
      questions,
      meta,
      slug
    })
    .then((res) => {
      return res.data
    })
}

export const getGame = ({
  _id
}) => {
  return strap()
    .get(`/games/${_id}`)
    .then((res) => {
      return res.data
    })
}

export const countGames = () => {
  return strap()
    .get(`/games/count`)
    .then((res) => {
      return res.data
    })
}

export const getSlug = ({
  slug
}) => {
  return strap()
    .get(`/games?slug=${slug}`)
    .then((res) => {
      return res.data || []
    })
}

export const updateGame = ({
  userID,
  game
}) => {
  return strap()
    .put(`/games/${game._id}?userID=${userID}`, game)
    .then((res) => {
      return res.data
    })
}

// export const removeGame = ({
//   userID,
//   game
// }) => {
//   return strap()
//     .delete(`/games/${game._id}?userID=${userID}`)
//     .then((res) => {
//       return res.data
//     })
// }

export const getLatestUserGames = ({
  userID,
  howMany = 10,
  skip = 0
}) => {
  return strap()
    .get(`/games?userID=${userID}&_limit=${howMany}&_start=${skip}&removed_ne=true`)
    .then((res) => {
      return res.data
    })
}

// ---- system --------
// require user to login first.
export const getYoqbJWT = () => {
  return strap()
    .post(`/systems/getYoqbJWT`)
    .then((res) => {
      LS.YOQBJWT = res.data.jwt
      LS.YOQBUID = res.data.uid
      return res.data
    })
}

export const getYOQB = async () => {
  if (LS.YOQBJWT && LS.YOQBUID) {
    return {
      jwt: LS.YOQBJWT,
      uid: LS.YOQBUID
    }
  } else {
    return getYoqbJWT()
  }
}

export const getFolderTitle = ({ gameID }) => {
  return `folder_${gameID}`
}

export const getFolderByTile = async ({ title }) => {
  // let yo = await getYOQB()
  let axios = require('axios')
  // let uid = yo.uid
  // let jwt = yo.jwt
  return axios({
    headers: {
      // 'Authorization': `bearer ${jwt}`
    },
    method: 'post',
    baseURL: 'https://yoteach-cloud.herokuapp.com',
    url: '/jwt/folder/detail-by-title',
    data: {
      title
    }
  }).then(e => e.data)
}

export const getFolderOfGame = async ({ gameID }) => {
  let yo = await getYOQB()
  let axios = require('axios')
  // let uid = yo.uid
  let jwt = yo.jwt
  let title = getFolderTitle({ gameID })
  return axios({
    headers: {
      'Authorization': `bearer ${jwt}`
    },
    method: 'post',
    baseURL: 'https://yoteach-cloud.herokuapp.com',
    url: '/jwt/folder/detail-by-title',
    data: {
      title
    }
  }).then(e => e.data)
}

export const createFolderForGame = async ({ gameID }) => {
  let yo = await getYOQB()
  let axios = require('axios')
  let uid = yo.uid
  let jwt = yo.jwt
  let title = getFolderTitle({ gameID })
  return axios({
    headers: {
      'Authorization': `bearer ${jwt}`
    },
    method: 'post',
    baseURL: 'https://yoteach-cloud.herokuapp.com',
    url: '/jwt/folder/add',
    data: {
      title,
      desc: title,
      userID: uid,
      tags: [
        title
      ]
    }
  }).then(e => e.data)
}

export const addQuestionToGame = async ({ gameID }) => {
  let QS = require('../yoqb-compos/question.js')
  let axios = require('axios')
  let yo = await getYOQB()
  let uid = yo.uid
  let jwt = yo.jwt
  // let title = getFolderTitle({ gameID })
  let folder = await getFolderOfGame({ gameID })
  let folderID = folder._id
  let document = QS.makeSampleQuestion()
  let questionOnly = QS.makeSampleQuestion()

  return axios({
    headers: {
      'Authorization': `bearer ${jwt}`
    },
    method: 'post',
    baseURL: 'https://yoteach-cloud.herokuapp.com',
    url: '/jwt/question/add',
    data: {
      folderID,
      userID: uid,
      document,
      questionOnly,
      title: `Question`
    }
  }).then(e => e.data)
}

export const listQuestionOfFolder = async ({ folderID }) => {
  // let QS = require('../yoqb-compos/question.js')
  // let yo = await getYOQB()
  let axios = require('axios')
  // let uid = yo.uid
  // let jwt = yo.jwt

  return axios({
    headers: {
      // 'Authorization': `bearer ${jwt}`
    },
    method: 'post',
    baseURL: 'https://yoteach-cloud.herokuapp.com',
    url: '/jwt/question/list-folder',
    data: {
      folderID
    }
  })
    .then(e => e.data)
    .then(e => {
      return sortInbound(e)
    })
}

export const listQuestionOnlyOfFolder = async ({ folderID }) => {
  // let QS = require('../yoqb-compos/question.js')
  // let yo = await getYOQB()
  let axios = require('axios')
  // let uid = yo.uid
  // let jwt = yo.jwt

  return axios({
    headers: {
      // 'Authorization': `bearer ${jwt}`
    },
    method: 'post',
    baseURL: 'https://yoteach-cloud.herokuapp.com',
    url: '/jwt/question/list-folder-question-only',
    data: {
      folderID
    }
  })
    .then(e => e.data)
    .then(e => {
      return sortInbound(e)
    })
}

export const getQuestionDetail = async ({ questionID }) => {
  // let QS = require('../yoqb-compos/question.js')
  let yo = await getYOQB()
  let axios = require('axios')
  // let uid = yo.uid
  let jwt = yo.jwt

  return axios({
    headers: {
      'Authorization': `bearer ${jwt}`
    },
    method: 'post',
    baseURL: 'https://yoteach-cloud.herokuapp.com',
    url: '/jwt/question/detail',
    data: {
      _id: questionID
    }
  }).then(e => e.data)
}

export const saveQuestionDetail = async ({ questionID }) => {
  // let QS = require('../yoqb-compos/question.js')
  let yo = await getYOQB()
  let axios = require('axios')
  // let uid = yo.uid
  let jwt = yo.jwt

  return axios({
    headers: {
      'Authorization': `bearer ${jwt}`
    },
    method: 'post',
    baseURL: 'https://yoteach-cloud.herokuapp.com',
    url: '/jwt/question/detail',
    data: {
      _id: questionID
    }
  }).then(e => e.data)
}

export async function removeQuestion ({ question: questionDBO }) {
  // let QS = require('../yoqb-compos/question.js')
  let yo = await getYOQB()
  let axios = require('axios')
  // let uid = yo.uid
  let jwt = yo.jwt

  return axios({
    headers: {
      'Authorization': `bearer ${jwt}`
    },
    method: 'post',
    baseURL: 'https://yoteach-cloud.herokuapp.com',
    url: '/jwt/question/remove-this',
    data: questionDBO
  }).then(e => e.data)

  // return request({
  //   url: '/jwt/question/remove-this',
  //   method: 'post',
  //   data
  // })
}

export async function updateQuestion ({ question: questionDBO }) {
  // let QS = require('../yoqb-compos/question.js')
  let yo = await getYOQB()
  let axios = require('axios')
  // let uid = yo.uid
  let jwt = yo.jwt

  return axios({
    headers: {
      'Authorization': `bearer ${jwt}`
    },
    method: 'post',
    baseURL: 'https://yoteach-cloud.herokuapp.com',
    url: '/jwt/question/update-this',
    data: questionDBO
  }).then(e => e.data)

  // return request({
  //   url: '/jwt/question/update-this',
  //   method: 'post',
  //   data
  // })
}

// session

export const getPin = () => {
  /*
  var mathRandom = (Math.random() * 1000000).toFixed(0)
  mathRandom = mathRandom.padStart(6, '0')
  */

  // Length of the random string.
  var len = 4
  // Generate the game code with 4 characters of digits and lower-case letters.
  var gameCode = Math.random().toString(36).substring(2, len + 2)
  return gameCode
}

export const createSessionData = ({ gameID }) => {
  let data = {
    userID: LS.UserID,
    responses: [],
    active: true,
    meta: {},
    players: [],
    pin: getPin(),
    state: {},
    datetime: new Date(),
    gameID: gameID
  }
  return data
}

export const createSession = (args) => {
  return strap()
    .post('/sessions', args)
    .then((res) => {
      return res.data
    })
}

export const getSessionByID = ({ sessionID }) => {
  return strap()
    .get(`/sessions/${sessionID}`)
    .then((res) => {
      return res.data
    })
}

export const getSessionByPin = ({ pin }) => {
  return strap()
    .get(`/sessions?pin=${pin}&active=true&_limit=1`)
    .then((res) => {
      return res.data[0]
    })
}

export const getActiveSessionOfUser = ({ limit = 1 }) => {
  return strap()
    .get(`/sessions?userID=${LS.UserID}&active=true&_limit=${limit}&_sort=createdAt:desc`)
    .then((res) => {
      return res.data
    })
}
export const getSessionReportsOfUser = ({ limit = 1, skip = 0 }) => {
  return strap()
    .get(`/sessions?userID=${LS.UserID}&_limit=${limit}&_start=${skip}&_sort=createdAt:desc`)
    .then((res) => {
      return res.data
    })
}

export const getGameSessionData = async ({ sessionID, isStudent = false }) => {
  try {
    let session = await getSessionByID({ sessionID: sessionID })
    let game = await getGame({ _id: session.gameID })
    let folder = false
    if (game.questions.folderType === 'autofolder') {
      folder = await getFolderByTile({ title: game.questions.autoFolderTitle })
    } else if (game.questions.folderType === 'manualfolder') {
      folder = await getFolderByTile({ title: game.questions.manualFolderTitle })
    }

    var questions = await listQuestionOnlyOfFolder({ folderID: folder._id })
    var questionsWithAns = await listQuestionOfFolder({ folderID: folder._id })

    return {
      session,
      game,
      folder,
      questions,
      questionsWithAns
    }
  } catch (e) {
    console.log(e)
    return null
  }
}

export const provideClientID = () => {
  let item = window.localStorage.getItem('BADABING_CLINET_ID')
  if (!item) {
    window.localStorage.setItem('BADABING_CLINET_ID', `_CLIENT_ID_${(Math.random() * 10000000000).toFixed(0)}`)
    item = window.localStorage.getItem('BADABING_CLINET_ID')
    return item
  } else {
    return item
  }
}

export const GamePlaySystem = ({
  sessionID,
  onSetup = () => {},
  onNotFound = () => {},
  onUpdateSession = () => {}
}) => {
  let api = {}
  let IO = io(getBaseURL() + `/BADABING`)
  api.IO = IO

  IO.on('update-session', (data) => {
    console.log('udpatesession', data)
    if (data.sessionID === sessionID) {
      onUpdateSession(data.session)
    }
  })

  IO.emit('join', { sessionID })

  getGameSessionData({ sessionID, isStudent: true })
    .then((data) => {
      onSetup(data)
    }, () => {
      onNotFound()
    })

  api.join = ({ name = 'Anonymous', members = [] }) => {
    IO.emit('join-game-player', {
      clientID: provideClientID(),
      members,
      sessionID: sessionID,
      name
    })
  }

  return api
}

export const GameHostSystem = ({
  sessionID,
  onSetup = () => {},
  onNotFound = () => {},
  onUpdateSession = () => {}
}) => {
  let api = {}
  let IO = io(getBaseURL() + `/BADABING`)
  api.IO = IO

  IO.on('update-session', (data) => {
    if (data.sessionID === sessionID) {
      onUpdateSession(data.session)
    }
  })

  IO.emit('join', { sessionID })
  IO.emit('join-game-host', {
    hostClientID: provideClientID(),
    token: LS.JWT,
    sessionID: sessionID
  })

  api.nextQuestion = ({ info }) => {
    info.session.state.host.page = 'questions'
    info.session.state.client.page = 'questions'

    if (info.session.state.question.index < info.questions.length - 1) {
      info.session.state.question.index += 1
      IO.emit('update-session', { sessionID, session: info.session, token: LS.JWT })
    }
  }
  // api.showQuestion = ({ info }) => {
  //   info.session.state.host.page = 'questions'
  //   info.session.state.client.page = 'questions'
  //   IO.emit('update-session', { sessionID, session: info.session, token: LS.JWT })
  // }

  api.resetQuestion = ({ info }) => {
    info.session.state.question.index = 0
    IO.emit('update-session', { sessionID, session: info.session, token: LS.JWT })
  }

  api.showAns = ({ info }) => {
    info.session.state.question.showAnswer = true
    IO.emit('update-session', { sessionID, session: info.session, token: LS.JWT })
  }

  api.showLeaderBoard = ({ info }) => {
    info.session.state.host.page = 'leaderboard'
    info.session.state.client.page = 'leaderboard'
    IO.emit('update-session', { sessionID, session: info.session, token: LS.JWT })
  }

  api.hideAns = ({ info }) => {
    info.session.state.question.showAnswer = false
    IO.emit('update-session', { sessionID, session: info.session, token: LS.JWT })
  }

  api.setDefault = ({ info }) => {
    info.session.state.game = info.session.state.game || {}

    info.session.state.host = info.session.state.host || {}
    info.session.state.client = info.session.state.client || {}

    info.session.state.question = info.session.state.question || {}

    let host = info.session.state.host
    let client = info.session.state.client
    let game = info.session.state.game
    let question = info.session.state.question
    let meta = info.session.meta

    if (typeof meta.gameTitle === 'undefined') {
      meta.gameTitle = info.game.title
    }

    if (typeof host.page === 'undefined') {
      host.page = 'lobby'
    }
    if (typeof client.page === 'undefined') {
      client.page = 'lobby'
    }
    if (typeof game.state === 'undefined') {
      game.state = 'ready'
    }
    if (typeof question.showAnswer === 'undefined') {
      question.showAnswer = false
    }
    if (typeof question.index === 'undefined') {
      question.index = 0
    }
    IO.emit('update-session', { sessionID, session: info.session, token: LS.JWT })
  }

  api.startGame = ({ info }) => {
    info.session.state.game.state = 'started'

    info.session.state.client.page = 'questions'
    info.session.state.host.page = 'questions'

    info.session.state.client.questionIndex = 0
    info.session.state.host.questionIndex = 0
    info.session.start = new Date()
    IO.emit('update-session', { sessionID, session: info.session, token: LS.JWT })
  }

  api.closeGame = ({ info, done = () => {} }) => {
    info.session = setSessionToEnd({ session: info.session })

    IO.emit('update-session', { sessionID, session: info.session, token: LS.JWT }, done)
  }

  getGameSessionData({ sessionID, isStudent: false })
    .then((data) => {
      onSetup(data)
      api.setDefault({ info: data })
    }, () => {
      onNotFound()
    })

  return api
}

export const setSessionToEnd = ({ session }) => {
  session.active = false
  session.state.game.state = 'end'
  session.state.client.page = 'endgame'
  session.state.host.page = 'endgame'
  if (!session.end) {
    session.end = new Date()
  }
  return session
}

export const closeGame = ({ sessionID, session }) => {
  let IO = io(getBaseURL() + `/BADABING`)

  session = setSessionToEnd({ session })

  IO.emit('update-session', { sessionID, session: session, token: LS.JWT }, () => {
    IO.disconnect()
  })
}

export const sendResponse = ({
  gameID,
  sessionID,
  userID,
  response,
  questionWithAns,
  questionID,
  correct,
  startTime,
  endTime,
  clientID
}) => {
  return strap()
    .post('/responses', {
      gameID,
      sessionID,
      userID,
      response,
      questionID,
      questionWithAns,
      correct,
      startTime,
      endTime,
      clientID
    })
    .then((res) => {
      return res.data
    })
}

export const getGameSessionResponses = async ({ sessionID }) => {
  let results = await strap()
    .get(`/responses?sessionID=${sessionID}&_limit=9000`)
    .then((res) => {
      return res.data
    })
  return results
}

export const getGameSessionLeaderboard = async ({ sessionID }) => {
  var results = await strap()
    .post(`/customs/getLeaderBoard`, { sessionID })
    .then((res) => {
      return res.data
    })
  return results
}

export const countSessionQuestionResponse = ({ sessionID, questionID }) => {
  return strap()
    .get(`/responses/count?sessionID=${sessionID}&questionID=${questionID}`)
    .then((res) => {
      return res.data
    })
}

export const countSessionResponse = ({ sessionID }) => {
  return strap()
    .get(`/responses/count?sessionID=${sessionID}`)
    .then((res) => {
      return res.data
    })
}

export const getGameSessionReport = async ({ limit = 1, skip = 0 }) => {
  var results = await strap()
    .get(`/customs/getSessionsWithResponse?userID=${LS.UserID}`)
    .then((res) => {
      return res.data
    })
  return results
}
